import { CreateOrgComponent } from "./create-org/createorg.component";
import { EditOrgComponent } from "./edit-org/editorganization.component";
import { RosterExcelMappingComponent } from "./roster-excel-mapping/roster-excel-mapping.component";
import { SingleOrgViewComponent } from "./view-org/single-view-org.component";
import { ViewOrgComponent } from "./view-org/vieworg.component";


export const MasterOrgDeclarations = [
    CreateOrgComponent,
    ViewOrgComponent,
    EditOrgComponent,
    SingleOrgViewComponent,
    RosterExcelMappingComponent
];